import {fork} from "redux-saga/effects";
import {watchImportICalTermine} from "./sagas/importICalTermineSaga";
import {watchDeleteTermin} from "./sagas/deleteTermin";
const terminSagas = [
    fork(watchImportICalTermine),
    fork(watchDeleteTermin)
]

export default terminSagas
